import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';
import { COLORS } from '../../../constants/colors';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: ReactNode;
  banner?: ReactNode;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  confirmDisabled?: boolean;
  variant?: 'primary' | 'danger' | 'warning';
}

export function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  banner,
  confirmText = 'Potwierdź',
  cancelText = 'Anuluj',
  isLoading = false,
  confirmDisabled = false,
  variant = 'primary',
}: ConfirmModalProps) {
  if (!isOpen) return null;

  const variantClass = variant === 'danger' ? 'btn-danger' : variant === 'warning' ? 'btn-warning' : 'btn-primary';

  return createPortal(
    <div
      className="modal modal-blur show position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ display: 'block', backgroundColor: COLORS.overlayBackground, zIndex: 1050 }}
      tabIndex={-1}
      role="dialog"
      onClick={onClose}>
      <div className="modal-dialog modal-sm modal-dialog-centered" role="document" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-body">
            {banner}
            <div className="modal-title fw-bold mb-2 text-break">{title}</div>
            <div className="text-secondary text-break">{message}</div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary me-auto" onClick={onClose} disabled={isLoading}>
              {cancelText}
            </button>
            <button type="button" className={`btn ${variantClass}`} onClick={onConfirm} disabled={isLoading || confirmDisabled}>
              {isLoading ? 'Ładowanie...' : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
